var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#EE741F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9273 22.4364C12.0724 22.4364 10.5626 20.9266 10.5626 19.0717V10.957H9.17718C7.97617 10.957 7 11.9331 7 13.1341V23.8218C7 25.0228 7.97617 25.999 9.17718 25.999H19.0731C20.2741 25.999 21.2503 25.0228 21.2503 23.8218V22.4364H13.9273Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4169 9.17718C24.4169 7.97458 23.4423 7 22.2399 7H13.9272C12.7246 7 11.75 7.97458 11.75 9.17718V19.0731C11.75 20.2757 12.7246 21.2503 13.9272 21.2503H22.2399C23.4423 21.2503 24.4169 20.2757 24.4169 19.0731V9.17718Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.4966a3a344d65ec6f996040996616e18.svg";
export { ForwardRef as ReactComponent };